module.exports = __webpack_public_path__ + "static/media/check-out_image.f345b07a.svg";